import s from '@/styles/components/GlobalLoading.module.scss'
import { CSSProperties, forwardRef, memo, PropsWithChildren } from 'react'
import { classNames } from '@tmap-web-lib/utils'

type Props = PropsWithChildren<{
  className?: string;
  style?: CSSProperties;
  imageSrc: string;
}>

const LoadingFullIndicator = memo(forwardRef<HTMLDivElement, Props>(
  function LoadingFullIndicator(props, ref) {
    const { children, className, style, imageSrc } = props
    return (
      <div className={classNames(s.wrap, className ? s[className] : undefined)} style={style} ref={ref}>
        {children ? children : <img src={imageSrc} width="50px" height="50px" alt=""/>}
      </div>
    )
  },
))

export { LoadingFullIndicator }
